module.exports = __webpack_public_path__ + "static/media/empty_image.1d00f8b7.png";